import { ToastMessage } from '@cokitchen/cokitchen-components';
import { DeleteIcon } from 'cokitchen-icons';
import useDashboardContext from 'contexts/dashboard.context';
import React from 'react';
import { TrailingActions as TrailingActionsPackage, SwipeAction } from 'react-swipeable-list';
import 'react-swipeable-list/dist/styles.css';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';
import { handleApiError } from 'utils/functions';

type Props = {
  id: string;
  loading: boolean;
  setLoading: (arg1: boolean) => void;
  isBranchAddress?: boolean;
};
const DeleteAddress = ({ id, loading, setLoading, isBranchAddress }: Props) => {
  const { refetchSavedAddressList, refetchBranchAddresses, activeCompany } = useDashboardContext();
  const handleDeleteAddress = async (id: string) => {
    if (loading) return;
    try {
      setLoading(true);
      await apiService.delete(`user-saved-address/${id}`, {
        baseURL: process.env.REACT_APP_CORE_API_URL
      });

      toast(<ToastMessage message='Address deleted successfully' type='success' />);
      refetchSavedAddressList();
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteBranchAddress = async (id: string) => {
    if (loading || !activeCompany) return;
    try {
      setLoading(true);
      await apiService.delete(`branches/${activeCompany.id}/${id}`);
      toast(<ToastMessage message='Address deleted successfully' type='success' />);
      refetchBranchAddresses();
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <TrailingActionsPackage>
      <SwipeAction
        onClick={() => (isBranchAddress ? handleDeleteBranchAddress(id) : handleDeleteAddress(id))}>
        <div className='w-[60px] h-[76.5px] py-[18px] text-white select-none flex justify-end'>
          <div
            className={`flex justify-center items-center w-8 h-8 rounded-full ${
              loading ? 'cursor-not-allowed bg-gray-9' : 'bg-red-5 cursor-pointer'
            }`}>
            <DeleteIcon className='h-6' />
          </div>
        </div>
      </SwipeAction>
    </TrailingActionsPackage>
  );
};

export default DeleteAddress;
